import { requst } from '../config'

// 树形多选框字典
export const getLocationDictTreeApi = locationId => {
    const url = locationId ? `/setting/location/checkTree?locationId=${locationId}` : `/setting/location/checkTree`
    return requst.get(url)
}

// 场所/营地
export const getLocationVesselOrCampDictTreeApi = (locationType, locationId) => {
    const url = locationId ? `/setting/location/modules/${locationType}?locationId=${locationId}` : `/setting/location/modules/${locationType}`
    return requst.get(url)
}

// 获取所有 location
export const getLocationListDataApi = projectId => {
    const url = `/setting/location/list?projectId=${projectId}`
    return requst.get(url)
}

/* 获取所有 location 新版权限 */
export const getLocationDataApi = menuCode => {
    const url = `/setting/location/getLocationListByMenu?menuCode=${menuCode}`
    return requst.get(url)
}

// 复制其它项目 location
export const getLocationProjectListDataApi = (sourceProjectId, targetProjectId) => {
    const url = `setting/location/importLocation?sourceProjectId=${sourceProjectId}&targetProjectId=${targetProjectId}`
    return requst.get(url)
}

// 查询分页数据
export const getLocationPageApi = params => {
    let url,
        query = ''
    const paramsList = Object.keys(params)
    paramsList.forEach(item => (query += `&${item}=${params[item]}`))
    const result = query.slice(1)
    url = `/setting/location/page?` + result
    return requst.get(url)
}

// 新增场所
export const postLocationDataApi = params => {
    const url = `/setting/location`
    return requst.post(url, params)
}

/* 编辑场所 */
export const putLocationDataApi = params => {
    const url = `/setting/location`
    return requst.put(url, params)
}

/* 删除 Location 表格数据 */
export const deletLocationTableDataApi = id => {
    const url = `/setting/location/${id}`
    return requst.delete(url)
}

/* 通过 id 获取项目 */
export const getLocationIdDataApi = id => {
    const url = `/setting/location/${id}`
    return requst.get(url)
}

// 提交时间段
export const postDatePeriodApi = params => {
    const url = `/setting/location/log`
    if (params?.id) {
        return requst.put(url, params)
    } else {
        return requst.post(url, params)
    }
}

// 删除时间段
export const deleteDatePeriodApi = id => {
    const url = `/setting/location/log/${id}`
    return requst.delete(url)
}

// 获取时间段
export const getDatePeriodListApi = params => {
    const url = `/setting/location/log/list?locationId=${params.locationId}&projectId=${params.projectId}`
    return requst.get(url)
}
